export default "__VITE_ASSET__Bh0J2Qcy__"